import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { GetDataForExpensePolicyPerDiemRateAsync, resetSelectedRecordObjectInState,GetAccountExpensePolicyPerDiemForEditAsync,DeleteAccountPerDiemLocationRateAsync,checkedState, unCheckedState,checkedAllState,unCheckedAllState,updateSorting } from './expensePolicyPerDiemSlice';
import { Link } from 'react-router-dom';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import ExpensePolicyPerDiemForm from './ExpensePolicyPerDiemForm';
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, getValueFromResource } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';

const ExpensePolicyPerDiemItem = (props: any) => {
    const { modelRef, expensePolicyPerDiemDetailList ,  expensePolicyPerDiem,onhandleOnClickEvent} = props;
    // console.log('expensePolicyPerDiemDetailList',expensePolicyPerDiemDetailList)
    
         const { cultureInfoName, decimalFormat, decimalPlaces } = useAppSelector((state) => state.globalState);

    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { isLoading,sortOrder, sortColumn, pageSize  } = useAppSelector((state) => state.expensePolicyPerDiem);

    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
   
    const onEditClick = (AccountExpensePolicyPerDiemLocationRateId: number) => {        
        dispatch(GetAccountExpensePolicyPerDiemForEditAsync(AccountExpensePolicyPerDiemLocationRateId))
            .unwrap()
            .then((originalPromiseResult) => {
                onhandleOnClickEvent({ name: t('Update Per Diem'),width: '800px',componentName: <ExpensePolicyPerDiemForm/>})
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('GetAccountExpensePolicyPerDiemForEditAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }

    const onDeleteClick = (AccountExpensePolicyPerDiemLocationRateId: string) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(DeleteAccountPerDiemLocationRateAsync(AccountExpensePolicyPerDiemLocationRateId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            ShowToast("Per diem deleted Successfully", 'Success', "success", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }
    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle " >

                        <th className='w-5px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    checked={expensePolicyPerDiemDetailList.every((item: any) => item.isSelected === 0) ? false :
                                        (expensePolicyPerDiemDetailList.every((item: any) => item.isSelected === 1 ? true : false))
                                    }
                                    onChange={handleSelectAllChange}
                                />
                            </div>
                        </th>
                        <th style={{ width: '25%' }}>
                            {/* {t('Location')} */}
                            {getValueFromResource('Location',dispatch, t)}
                        {sortColumn === 'PerDiemLocationName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "PerDiemLocationName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "PerDiemLocationName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "PerDiemLocationName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "PerDiemLocationName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Per Diem Type')} */}
                            {getValueFromResource('Per Diem Type',dispatch, t)}
                        {sortColumn === 'AccountExpensePolicyPerDiemTypeName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountExpensePolicyPerDiemTypeName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountExpensePolicyPerDiemTypeName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountExpensePolicyPerDiemTypeName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountExpensePolicyPerDiemTypeName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Effective Date')} */}
                            {getValueFromResource('Effective Date',dispatch, t)}
                        {sortColumn === 'EffectiveDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "EffectiveDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "EffectiveDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "EffectiveDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "EffectiveDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '18%'}}>
                            {/* {t('Rate')} */}
                            {getValueFromResource('Rate',dispatch, t)}
                        {sortColumn === 'PerDiemRate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "PerDiemRate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "PerDiemRate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "PerDiemRate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "PerDiemRate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-5 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                  
                    {expensePolicyPerDiemDetailList.length > 0 && expensePolicyPerDiemDetailList.map((PerDiemDetails: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        type="checkbox"
                                        className="form-check-input widget-9-check "
                                        checked={PerDiemDetails.isSelected == 0 ? false : true}
                                        onChange={(e) => { handleCheckboxChange(e, PerDiemDetails.AccountExpensePolicyPerDiemLocationRateId) }}

                                    />
                                </div>
                            </td>
                            <td>
                            <a id="kt_OffCanvas"
                                    className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => { onEditClick(PerDiemDetails.AccountExpensePolicyPerDiemLocationRateId)}}>                                   
                                    {PerDiemDetails.PerDiemLocationName} 
                                </a>
                            </td>
                            <td>
                                {PerDiemDetails.AccountExpensePolicyPerDiemTypeName}
                            </td>
                            <td>
                                {formatDateWithDateAndMonthName(PerDiemDetails.EffectiveDate
                                    ? PerDiemDetails.EffectiveDate.split("/").reverse().join("-")
                                    : "", cultureInfoName.toString())}
                            </td>
                            <td style={{textAlign:'center'}}>
                            {PerDiemDetails.CurrencyCode} {FormatInvoiceDecimalNumber(cultureInfoName.toString(), PerDiemDetails.PerDiemRate, decimalPlaces)}
                            </td>

                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                            <div className='menu-hover-bg-sec'>
                                                <Dropdown.Item
                                                    id="kt_OffCanvas"
                                                    className="menu-item me-lg-0 "
                                                    onClick={() => { onEditClick(PerDiemDetails.AccountExpensePolicyPerDiemLocationRateId) }}
                                                >
                                                    <span className="menu-icon custom-menu">
                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <span className="menu-title custom-menu-fontsize">
                                                        {/* {`${t('Edit')}`} */}
                                                        {getValueFromResource('Edit',dispatch, t)}
                                                        </span>
                                                </Dropdown.Item>
                                            </div>
                                            <div className='separator mb-1 mt-1 opacity-75 '></div>

                                            <div className='menu-hover-bg-danger'>
                                                <Dropdown.Item
                                                    className="menu-item me-lg-0 "
                                                    onClick={() => { onDeleteClick(PerDiemDetails.AccountExpensePolicyPerDiemLocationRateId) }}
                                                >
                                                    <span className="menu-icon  custom-menu">
                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                        {/* {`${t('Delete')}`} */}
                                                        {getValueFromResource('Delete',dispatch, t)}

                                                        
                                                        </span>
                                                </Dropdown.Item>
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>
            {expensePolicyPerDiemDetailList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
        </>
    )
}

export default ExpensePolicyPerDiemItem